import { getRetailSpecificationPage } from './index';
import { createSelector } from '@ngrx/store';
import { getAnticipatedInvoice } from '../../review/reducers/review.selectors';

export const getRetailSpecificationForm = createSelector(
  getRetailSpecificationPage,
  state => state.retailSpecificationState,
);

export const getRecipeState = createSelector(
  getRetailSpecificationPage,
  state => state.retailSpecificationState.forms,
);

export const recipeAndInvoice = createSelector(
  getRetailSpecificationForm,
  getAnticipatedInvoice,
  (specificaiton, invoice) => {
    return {
      invoiceLoaded: specificaiton.invoiceLoaded,
      recipe: specificaiton.forms,
      invoice: invoice,
    };
  },
);

export const getNewOrderCreation = createSelector(
  getRetailSpecificationForm,
  state => state.newOrderCreation);
